<template>
    <div class="discuss-hot-list">
        <virtual-list
            ref="vsl"
            v-show="!!hotLunpanList.length"
            id="DiscussHotVirtualList"
            class="overflow-y-scroll scroll-touch"
            :data-key="'id'"
            :data-sources="hotLunpanList"
            :data-component="itemComponent"

            :estimate-size="50"
            :footer-class="'famous-list-note'"
            v-on:tobottom="onScrollToBottom">
            <div v-show="parseInt(hotLunpanTotalData.nowpage) < parseInt(hotLunpanTotalData.totalpage)" slot="footer" class="lds-dual-ring lds-dual-ring-gray"></div>
        </virtual-list>
    </div>
</template>

<script>
import DiscussMainItem from '../../components/discuss/DiscussMainItem.vue'
export default {
    name: 'DiscussHotVirtualList',
    computed: {
        hotLunpanList() {
            return this.$store.state.discuss.hotLunpanList;
        },
        hotLunpanTotalData() {
            return this.$store.state.discuss.hotLunpanTotalData;
        }
    },
    data() {
        return {
            itemComponent: DiscussMainItem,
        }
    },
    mounted() {
        this.$bus.on('updateDiscussHotListDom', this.initDom);
    },
    destroyed() {
        this.$bus.off('updateDiscussHotListDom', this.initDom);
    },
    methods: {
        initDom() {
            var titleDom = document.getElementsByClassName('discuss-main-title')[0],
                bottomDom = document.getElementsByClassName('bottom-menu-bar')[0],
                listDom = document.getElementsByClassName('discuss-main-list')[0];
            var height = titleDom ? innerHeight-titleDom.clientHeight : innerHeight;
                height = bottomDom ? height-bottomDom.clientHeight : height;
            this.$el.style.height = height+'px';
            if(listDom) {
                if(titleDom) {
                    listDom.style.paddingTop = titleDom.clientHeight+'px';
                }
                if(bottomDom) {
                    listDom.style.paddingBottom = bottomDom.clientHeight+'px';
                }
            }
            var curDom = document.getElementById('DiscussHotVirtualList');
            if(curDom) {
                curDom.style.height = height+'px';
            }
        },
        onScrollToBottom() {
            // 下拉加载更新列表数据
            this.$store.dispatch('discuss/initHotLunPanList', {
                update: true
            });
        }
    }
}
</script>